import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { observer } from "mobx-react-lite"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

type TIntervalTypes = "countdown" | "session"

interface TimeoutProps {
	isAnonymous: boolean
	autoLogOut: () => void
	manualLogOut: () => void
}

let countdownInterval: NodeJS.Timeout
let session: NodeJS.Timeout

const SessionTimeout = observer(({ isAnonymous, autoLogOut, manualLogOut }: TimeoutProps) => {
	const store = useStore()
	const { t } = useTranslation()
	const [timeoutCountdown, setTimeoutCountdown] = useState(0)
	/**
	 * useRef used due to useState not updated in setTimeout()
	 */
	// TODO : Rework logic to use useState
	const modalRef = useRef(false)

	const setTime = () => {
		if (!isAnonymous){
			// 18 min (2 less then BE made)
			let sessionWarning = 60000 * 18
			session = setTimeout(() => onIdle(), sessionWarning)
		}
	}

	const clearTimeouts = (type: TIntervalTypes) => {
		switch (type) {
			case "session":
				clearTimeout(session)
				break
			case "countdown":
				clearInterval(countdownInterval)
				break
		}
	}

	useEffect(() => {
		clearTimeouts("session")
		clearTimeouts("countdown")
		modalRef.current = false
		// request to BE update session timeout to 20
		setTime()
	}, [store.sessionTimeout])

	const handleLogout = async (isAuto = false) => {
		try {
			modalRef.current = false
			clearTimeouts("session")
			clearTimeouts("countdown")
			!isAuto && manualLogOut()
			isAuto && autoLogOut()
		} catch (err) {
			console.error(err)
		}
	}
	const handleContinue = () => {
		modalRef.current = false
		setTimeoutCountdown(0)
		clearTimeouts("session")
		clearTimeouts("countdown")
		getUser()
	}

	const getUser = async () => {
		const { ok, data, statusCode } = await AppRequests("User").get<boolean>("renew")
		if (ok && data) {
			setTime()
		} else if (statusCode == 401) {
			handleLogout(false)
		}
	}

	const onIdle = () => {
		clearTimeouts("session")
		const delay = 1000 * 1
		if (!isAnonymous && !modalRef?.current) {
			session = setTimeout(() => {
				let countDown = 60
				modalRef.current = true
				setTimeoutCountdown(countDown)
				countdownInterval = setInterval(() => {
					if (countDown > 0) {
						setTimeoutCountdown(--countDown)
					} else {
						handleLogout(true)
					}
				}, 1000)
			}, delay)
		}
	}

	useEffect(() => {
		modalRef?.current &&
			store.setInfoModalConfig({
				type: "warning",
				titleKey: t("user.end-session-warning"),
				descriptionKey: `${t("user.end-time")} ${timeoutCountdown.toString()} sec`,
				proceedTextKey: t("button.renew"),
				onProceed: () => handleContinue(),
				showCancelBtn: true,
				cancelTextKey: t("rawText.back-start"),
				onCancel: () => {
					handleLogout(false)
					store.resetInfoModalConfig()
				},
			})
	}, [modalRef?.current, timeoutCountdown])

	return <></>
})

export default SessionTimeout
